/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { Checkbox, Heading } from 'sarsaparilla';
import { SEARCH_FILTER_START_TIME } from '../../../constants/index';

type StartTimeFilterItem = {
    key: string;
    value: string;
    filters: { attribute: string; filterValue: string }[];
};

interface StartTimeFiltersProps {
    uiFilters: {
        tourTimes?: Record<string, unknown>;
    };
    onFilterToggle: (filterName: string, item: StartTimeFilterItem) => void;
}

export function StartTimeFilters({ onFilterToggle, uiFilters }: StartTimeFiltersProps) {
    const handleChange = (item: StartTimeFilterItem) => {
        onFilterToggle('tourTimes', item);
    };

    return (
        <div>
            <Heading headingLevel={3} appearance="h3" className="mt-0 mb-2 pt-0">
                Start Time
            </Heading>
            <div
                className="search-filters-double-type-wrap"
                role="group"
                aria-label="Tour type filters"
            >
                {SEARCH_FILTER_START_TIME.map((item) => {
                    const selections = uiFilters.tourTimes ?? {};
                    const isChecked = Object.hasOwn(selections, item.key);

                    return (
                        <div className="search-filter-check-item" key={item.key}>
                            <Checkbox
                                label={item.value}
                                id={item.key}
                                value={item.value}
                                isChecked={isChecked}
                                onChange={() => handleChange(item)}
                            />
                        </div>
                    );
                })}
            </div>
        </div>
    );
}
